import { window } from "../window";

/**
 * Resets and controls the browser's navigation history to prevent unwanted back navigation.
 *
 * @description
 * 1. Captures the current path
 * 2. Pushes two new history entries with the current path
 * 3. Goes back one step in history
 * 4. Sets up a popstate event listener to prevent navigation
 *
 * Uses this sequence to ensure that when a user clicks the browser's back button,
 * they remain on the current page instead of navigating away.
 *
 * @returns {Function} A cleanup function that removes the popstate event listener when called.
 * This should be called when the component unmounts to prevent memory leaks.
 *
 * @example
 * useEffect(() => {
 *   const cleanup = resetBrowserNavigationHistory();
 *   return cleanup;
 * }, []);
 *
 */

export const resetBrowserNavigationHistory = () => {
  const currentPath = window.location.pathname;
  const searchParams = new URLSearchParams(window.location.search);
  const fullUrl = currentPath + (searchParams.toString() ? `?${searchParams.toString()}` : "");

  window.history.pushState("", "", fullUrl);
  window.history.pushState("", "", fullUrl);
  window.history.go(-1);

  const preventNavigation = () => {
    window.history.pushState(null, "", fullUrl);
  };

  window.addEventListener("popstate", preventNavigation);

  return () => {
    window.removeEventListener("popstate", preventNavigation);
  };
};
